import { CustomDateRange } from './customDateRange';
import * as _ from "lodash";
import * as moment from 'moment'

export function generateDatesByCustomRange(dateRange: CustomDateRange) {
    if (dateRange === CustomDateRange.Today) {
        return {
            startTs: +moment().startOf('day'),
            endTs: +moment().endOf('day'),
        };
    }

    if (dateRange === CustomDateRange.Yesterday) {
        const initDate = moment().add(-1, 'days');
        return {
            startTs: +initDate.startOf('day'),
            endTs: +initDate.endOf('day'),
        };
    }
    if (dateRange === CustomDateRange.ThisWeek) {
        return {
            startTs: +moment().startOf('isoWeek'),
            endTs: +moment().endOf('isoWeek'),
        };
    }
    if (dateRange === CustomDateRange.ThisMonth) {
        return {
            startTs: +moment().startOf('month'),
            endTs: +moment().endOf('month'),
        };
    }
    if (dateRange === CustomDateRange.LastWeek) {
        const initDate = moment().add(-1, 'week');
        return {
            startTs: +initDate.startOf('isoWeek'),
            endTs: +initDate.endOf('isoWeek'),
        };
    }
    if (dateRange === CustomDateRange.LastMonth) {
        const initDate = moment().add(-1, 'month');
        return {
            startTs: +initDate.startOf('month'),
            endTs: +initDate.endOf('month'),
        };
    }
    if (dateRange === CustomDateRange.Last7Days) {
        return {
            startTs: +moment().add(-7, 'days').startOf('day'),
            endTs: +moment().add(-1, 'days').endOf('day'),
        };
    }
    if (dateRange === CustomDateRange.Last30Days) {
        return {
            startTs: +moment().add(-30, 'days').startOf('day'),
            endTs: +moment().add(-1, 'days').endOf('day'),
        };
    }
    return {
        startTs: null,
        endTs: null,
    };
}
